/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-22 16:03:36
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 17:13:13
 */
import ColumnTypes from '@/utils/ColumnTypes';
const name = {
	key: 'name',
	label: '部门名称',
	type: () => import('./components/tableCells/labelCell.vue'),
	minWidth: '265',
	headerAlign: 'left',
	fixed: 'left',
};
const nickame = {
	key: 'nickame',
	label: '负责人',
	type: ColumnTypes.TextCell,
	minWidth: '235',
	headerAlign: 'left',
};
const deptUserNum = {
	key: 'deptUserNum',
	label: '部门人数',
	type: ColumnTypes.TextCell,
	minWidth: '290',
	headerAlign: 'left',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: () => import('./components/tableCells/remarkCell.vue'),
	minWidth: '265',
	headerAlign: 'left',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	width: '300',
	headerAlign: 'left',
	mode: 'vertical',
	fixed: 'right',
};

export const columns = [name, nickame, deptUserNum, remark, operations];
